/* global angular */
angular.module('ua5App')
    .directive('loader', [function() {
        return {
            restrict: 'E',
            templateUrl: 'components/loader/loader.html',
            link: function($scope, $element, $attrs) {
                $scope.$on('$stateChangeStart', function() {
                    $scope.hide = false;
                });
                $scope.$on('$stateChangeSuccess', function() {
                    $scope.hide = true;
                });
                $scope.$on('showLoader', function() {
                    $scope.hide = false;
                });
                $scope.$on('hideLoader', function() {
                    $scope.hide = true;
                    $scope.$apply();
                });
            }
        };
    }])
;
